export const CRUDABLE_RESOURCES = [
  'recruit',
  'tourney',
];


// WEBPACK FOOTER //
// ./src/js/GameDay/constants.js